import { Component, OnInit, Input } from '@angular/core';
import { DadosService } from '../../db/dados.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { GeoipService } from '../../services/geoip.service';
import { UsersService } from '../../../../models/usuarios.service';

@Component({
  selector: 'app-dados-cliente',
  templateUrl: './dados-cliente.component.html',
  styleUrls: ['./dados-cliente.component.scss']
})
export class DadosClienteComponent implements OnInit {
  location: any;
  entrega: any = {};
  form: FormGroup;

  constructor(
    private dados: DadosService,
    private router: Router,
    private _fb: FormBuilder,
    //private geoip: GeoipService,
    private users: UsersService) {

  }

  ngOnInit() {
   // this.location = this.geoip.location;
   // this.geoip.findMe().subscribe(ret => {
   //   this.location = ret;
   // });
    this.form = new FormGroup(
      {
        cpf: new FormControl(),
        nome: new FormControl(),
        ender: new FormControl(),
        fone: new FormControl(),
        cidade: new FormControl(),
        estado: new FormControl(),
        bairro: new FormControl(),
        refer: new FormControl(),
        cep: new FormControl(),
      }
    );
    this.entrega = this.dados.entrega;
    if ((this.entrega == null) || (this.entrega = {}))
      this.usarUltimoEndereco();


    // checa se esta logado
    if (!this.users.logado) {
      this.router.navigate(['/login']);
    } else
    {
      //console.log(this.entrega);
      if ((this.entrega==null)|| (!this.entrega.cpf))
        this.entrega = this.users.usuario;
    }

  }


  get carrinho(){
    //console.log(this.dados.carrinho.items);
    return this.dados.carrinho.items;
  }


  @Input()
  get entregaX() {
    return this.dados.entrega;
  }
  set entregaX(x) {
    this.dados.entrega = x
  }

  continuarClick(x) {
    if (this.form.valid) {
      this.dados.entrega = this.entrega;
      this.router.navigate(['/pagamento']);
    }
  }

  limpar() {
    this.entrega = {};
  }

  temEntrega() {
    return (this.entrega.cpf != '' ? true : false);
  }

  usarUltimoEndereco() {
    if (this.dados.ultimaEntrega != null) {
      this.entrega = Object(this.dados.ultimaEntrega);
    } else {
    }
  }

  checkValid() {
    return this.form.valid;
  }

  logout()
  {
    this.users.logout();
    this.router.navigate(['/login']);
  }


  getNome(nome){
    if (nome.length<50)
      return nome ;
      else
      return nome.substring(0,50)+'...';
  }
 

  getCount(){
    return this.carrinho.length;
  }
  get count(){
    return this.getCount();
  }
  get subTotal(){
    return this.dados.carrinho.subTotal;
  }
  get freteTotal(){
    return this.dados.carrinho.freteTotal;
  }

  get total(){
    return this.dados.carrinho.total;
  }

}
